import React, { useEffect } from 'react';
import { ResponsiveContainer, PieChart, Cell, Tooltip, Pie } from 'recharts';

const PieC = ({ data }: { data: any }) => {
  useEffect(() => {
    console.log(data);
  }, [data]);
  return (
    <div className="w-full h-[50dvh] ">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            outerRadius={60}
            fill="#8884d8"
            dataKey="value"
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip
            contentStyle={{
          
              border: '1px solid #374151',
              borderRadius: '8px',
            }}
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default PieC;
